import { type FieldType } from '.';
import BaseField from './BaseField';

class TextField extends BaseField {
  type: FieldType = 'TextField';
}

export default TextField;
